import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import { useCallback, useMemo } from 'react';

import type { TWorkplaceFormFields } from 'entities/creditForm';

export const useUpdateWorkFields = () => {
  const { setValue, trigger } = useFormContext<TWorkplaceFormFields>();

  const updateWorkFields = useCallback(
    async (updateData: Partial<TWorkplaceFormFields>, shouldValidate = false) => {
      const updatedFields = Object.keys(updateData) as Array<keyof TWorkplaceFormFields>;

      updatedFields.forEach((fieldKey) => {
        setValue(fieldKey, updateData[fieldKey]);
      });

      if (shouldValidate) {
        await trigger(updatedFields);
      }
    },
    [setValue, trigger],
  );

  return useMemo(
    () => ({
      updateWorkFields,
      resetFields: () =>
        updateWorkFields({
          workOrganizationName: '',
          workAddress: null,
          workPhone: '',
          employerInn: '',
          areaOfEmployment: null,
          employerType: null,
        }),
    }),
    [updateWorkFields],
  );
};
